import { gql } from 'graphql-tag';
import { type GetBudgetSupportTypesListQuery } from 'src/app/shared/graphql/agreements/get-budget-support-types-query.graphql.autogenerated';

export type GetBudgetSupportTypesListResult = GetBudgetSupportTypesListQuery['budgetSupportTypes'];
export type BudgetSupportType =
  GetBudgetSupportTypesListQuery['budgetSupportTypes']['defaultBudgetSupportTypes'][number];

export const GetBudgetSupportTypesListDocument = gql`
  query getBudgetSupportTypesList($consumerUserId: ID, $postedJobId: ID) {
    budgetSupportTypes(consumerUserId: $consumerUserId, postedJobId: $postedJobId) {
      defaultBudgetSupportTypes {
        id
        name
        displayName
        isAdminOnlyType
      }
      availableBudgetSupportTypes {
        id
        name
        displayName
        isAdminOnlyType
      }
    }
  }
`;
